<template>
  <div
    class="account-insured-search-window"
    :class="{ 'account-insured-search-window--embedded': embedded }"
    :style="embedded ? undefined : { zIndex }"
    role="dialog"
    :aria-label="$t('commonSearchTitle')"
  >
    <div class="account-insured-search-dialog">
      <div class="account-dual-header">
        <span class="account-dual-header__title">{{ $t("commonSearchTitle") }}</span>
      </div>
      <div class="account-insured-search-dialog__body">
        <AccountPersonSearchPanel
          :pin="pin"
          :doc-series="docSeries"
          :doc-number="docNumber"
          :search-mode="searchMode"
          :loading="loading"
          @update:pin="$emit('update:pin', $event)"
          @update:doc-series="$emit('update:docSeries', $event)"
          @update:doc-number="$emit('update:docNumber', $event)"
          @update:search-mode="$emit('update:searchMode', $event)"
          @search="$emit('search')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AccountPersonSearchPanel from "./AccountPersonSearchPanel.vue";

export default {
  name: "AccountPersonSearchDialog",
  components: { AccountPersonSearchPanel },
  props: {
    modelValue: { type: Boolean, default: false },
    pin: { type: String, default: "" },
    docSeries: { type: String, default: "" },
    docNumber: { type: String, default: "" },
    searchMode: { type: String, default: "asan" },
    loading: { type: Boolean, default: false },
    zIndex: { type: Number, default: 3008 },
    embedded: { type: Boolean, default: false },
  },
  emits: [
    "update:modelValue",
    "update:pin",
    "update:docSeries",
    "update:docNumber",
    "update:searchMode",
    "search",
  ],
};
</script>
